import 'core-js/stable';
import 'regenerator-runtime/runtime';
if (process.env.NODE_ENV === 'production') { 
     require('./index.prod.js');
} else if (process.env.NODE_ENV === 'qa') {
    require('./index.qa.js');
} else
   require('./index.dev.js');

